
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import { getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { newGUID } from '../../utils/util';
const Crypto = require('crypto-js');
//const dateFormat = require('dateformat');
export default function VNPayInitOrder(props) {
    const [showLoading, setShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    let api ='https://sandbox.vnpayment.vn/paymentv2/vpcpay.html' 
    const terminalCode = 'ZHMVRZEZ'
    const serectCode = 'VWSMYTSLPKMSZIODQWRNSLHIVICTNUCV'
    const [url, setUrl] = useState(null);
    const orderId = getOrderCache(order_key.estimate_order_result).id


    const orderAmount = props.amount ? props.amount * 100 : 0
    useEffect(() => {
        onVNPay();
    }, []);

    const onVNPay = async () =>{
        
        var date = new Date();
        var month = (date.getMonth() + 1)
        if (month < 10){
            month = '0'+month
        }
        var createDate = '' + date.getFullYear() + '' + month + '' + date.getDate() + '' + date.getHours()+''+date.getMinutes()+''+date.getSeconds() //dateFormat(date, 'yyyymmddHHmmss');
        
        //console.log('window===', window)
       // var orderId = estimate_order_result.id ? estimate_order_result.id : null; //dateFormat(date, 'HHmmss');
        let token = orderId + '-' + createDate;
        setOrderCache(order_key.order_token, token);
        let vnp_Params = {};
        vnp_Params['vnp_Version'] = '2.1.0';
        vnp_Params['vnp_Command'] = 'pay';//
        vnp_Params['vnp_TmnCode'] = terminalCode;
        vnp_Params['vnp_Locale'] = 'vn';
        vnp_Params['vnp_CurrCode'] = 'VND';
        vnp_Params['vnp_TxnRef'] = token;
        vnp_Params['vnp_OrderInfo'] = 'Pay for Coffee Direct '+ createDate;
        vnp_Params['vnp_OrderType'] = 'other';
        vnp_Params['vnp_Amount'] = orderAmount;
        vnp_Params['vnp_ReturnUrl'] = window.location.origin + '/vnpay/order';
        vnp_Params['vnp_IpAddr'] = '14.248.71.112';
        vnp_Params['vnp_CreateDate'] = createDate;
        vnp_Params['vnp_BankCode'] = 'NCB';
        
    
        vnp_Params = sortObject(vnp_Params);
        console.log('vnp_Params====', vnp_Params)
        //let hex_md5v = md5.hex_md5( 'VWSMYTSLPKMSZIODQWRNSLHIVICTNUCV' +  vnp_Params);
        
        var querystring = require('qs');
        var signData = querystring.stringify(vnp_Params, { encode: false });

        var hmac = Crypto.HmacSHA512(signData,serectCode)
        hmac = hmac.toString(Crypto.enc.Hex);
        console.log("Hash hmac: ", hmac);
        vnp_Params['vnp_SecureHash'] = hmac;

        var querystring = require('qs');

        const url = api + '?' + querystring.stringify(vnp_Params, { encode: false });
        setUrl(url);
        window.parent.location.replace(url);
        //console.log('url===', url)
    }
    function sortObject(obj) {
        var sorted = {};
        var str = [];
        var key;
        for (key in obj){
        if (obj.hasOwnProperty(key)) {
        str.push(encodeURIComponent(key));
        }
        }
        str.sort();
        for (key = 0; key < str.length; key++) {
            sorted[str[key]] = encodeURIComponent(obj[str[key]]).replace(/%20/g, "+");
        }
        return sorted;
    }



    return (
        <div/>
    )
}
